jQuery('.PartnersAd').each(function() {
    const partnersAd = jQuery(this);
    const partnersAdsCards = partnersAd.find('li');
    const min = 1;
    const max = partnersAdsCards.length;
    const partnersAdsSelectedIndex = Math.floor(min + Math.random() * (max + 1 - min));

    partnersAdsCards.hide();
    partnersAd.find(`li:eq(${partnersAdsSelectedIndex - 1})`).show();
});

// window.dataLayer = window.dataLayer || [];
// function at_gtag(){dataLayer.push(arguments);}
// at_gtag('js', new Date());
// at_gtag('config', ga4code);


ga4code = window.ga4_analytics_id;
// window.dataLayer = window.dataLayer || [];

// function at_gtag(){dataLayer.push(arguments);};
// at_gtag('js', new Date());
// at_gtag('config', ga4code,{ 'send_page_view': false });


// jQuery(document).ready( function() {
//     jQuery( '.ad-tracking' ).each( function() {
//         sendImpression_GA4(this);
//     });
//     jQuery( '.ad-tracking a' ).on( "click", function(e) {
//         sendClick_GA4(this);
//     });
// });

// function sendImpression_GA4 (adobject) {
//     adbrand = jQuery(adobject).data('sp-brand');
//     adcampaign = jQuery(adobject).data('sp-content');
//     adspotlocation = jQuery(adobject).data('sp-location');
//     adgeotarget = 'none';
//     at_gtag('event', 'rain_ad_impression', {
//         'ad_brand': adbrand,
//         'ad_campaign': adcampaign,
//         'ad_location': adspotlocation,
//         'ad_geotarget': adgeotarget
//     });
// }


// function sendClick_GA4(adobject) {
//     adobject = jQuery(adobject).parent();
//     adbrand = jQuery(adobject).data('sp-brand');
//     adcampaign = jQuery(adobject).data('sp-content');
//     adspotlocation = jQuery(adobject).data('sp-location');
//     adgeotarget = 'none';
//     at_gtag('event', 'rain_ad_click', {
//         'ad_brand': adbrand,
//         'ad_campaign': adcampaign,
//         'ad_location': adspotlocation,
//         'ad_geotarget': adgeotarget
//     });
// }
//
//
// ////this used to be on indian-wells
//
// /*
// 	to be consistent
// 	Event action = ad location
// 	Event Label = brand
// 	Event Category = Impression or click
// */
// (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
//   (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
//   m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
//   })(window,document,'script','//www.google-analytics.com/analytics.js','gaTracker');
// 	gaTracker('create', 'UA-4616629-8');
// function sendImpression(adbrand, adlocation){
// 		if(adbrand != undefined){
// 			gaTracker('send', {
// 				hitType: 'event',
// 				eventCategory: "Sponsored impression",
// 				eventAction: adlocation,
// 				eventLabel: adbrand,
// 				transport: 'beacon'
// 			});
// 		}
// 	}
// 	function sendClick(adbrand, adlocation, adlink) {
// 		if(adbrand != undefined && adlink !="" && adlink != "#"){
// 			gaTracker('send', {
// 				hitType: 'event',
// 				eventCategory: "Sponsored click",
// 				eventAction: adlocation,
// 				eventLabel: adbrand,
// 				transport: 'beacon'
// 			});
// 		}
// 	}
// jQuery(document).ready( function () {
// 	jQuery('.ad-tracking').each( function () {
// 		if ( jQuery(this).is(":visible")) {
// 			adbrand = jQuery(this).data('sp-content');
// 			adlocation = jQuery(this).data('sp-location');
// 			sendImpression(adbrand,adlocation);
// 			console.log("send impression", adbrand, adlocation );
// 		}
// 	});
// 	jQuery('.ad-tracking').click( function () {
// 		adbrand = jQuery(this).data('sp-content');
// 		adlocation = jQuery(this).data('sp-location');
// 		adlink = jQuery(this).attr('href');
// 		sendClick(adbrand,adlocation,adlink);
// 	});
// });
